<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="
        vx-col
        flex
        items-center
        justify-center
        flex-col
        sm:w-1/2
        md:w-3/5
        lg:w-3/4
        xl:w-1/2
        mx-auto
        text-center
      "
    >
      <img
        src="@/assets/images/pages/maintenance-2.png"
        alt="graphic-maintenance"
        class="mx-auto mb-4"
      />
      <h1 class="sm:mx-0 mx-4 mb-6 text-5xl d-theme-heading-color">
        Timeout Expired
      </h1>
      <p class="sm:mx-0 mx-4 mb-6 d-theme-text-inverse">
        Your account has NOT been activated.
      </p>
      <vs-button size="large" @click="resendConfirmation()">Resend Confirmation</vs-button>
    </div>
  </div>

</template>
<script>
import Swal from 'sweetalert2'
export default {
  methods: {
    resendConfirmation() {
      Swal.fire({
              title: 'Resend Email Confirmation?' ,
              text: "",
              input: 'text',
              inputPlaceholder:'Enter UserName',
              icon: 'warning',
              customClass: {
                  icon: "no-before-icon",
              },
              showCancelButton: true,
              confirmButtonColor: '3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Resend',
               inputValidator: (value) => {
                    return new Promise((resolve) => {
                        if (value !== '') {
                            resolve()
                        } else {
                            resolve('UserName is Required!')
                        }
                    })
              }
            }).then((result) => {
                if (result.isConfirmed) {
                  this.$vs.loading()
                    this.$store.dispatch('hrms/resendConfirmation', result.value)
                     .then((response) => { 
                            this.$vs.loading.close()
                            if(response.status == 200)
                                this.$alert("Please check your email and verify your account.", "Resend Email Successful", "success")
                            else
                                this.$alert("", response.statusText, "error")
                        })
                    .catch((error) => { 
                            this.$vs.loading.close()
                            this.$alert( error.message, "Error", "error")
                    
                        })

                } else
                    this.$alert("", 'Cancelled', "info")
            })


      
    }
  },
}
</script>
